import { ResumePetisSimulationProposalClientResponse } from '../../../@types/ResumePetisSimulationProposal'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'

export const useCreateProposalHydration = () => {
  const { setCreateProposal, setHasCreatedProposal } = useCreateProposalStore()

  const handleCreateProposalHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    setCreateProposal({
      createProposalResponse: {
        proposalId:
          data.processData?.task?.policyId ||
          data.processData?.proposalData?.proposalId ||
          data.processData?.policyData?.policyId,
      },
    })

    if (data.processData?.proposalData?.proposalId) {
      setHasCreatedProposal(true)
    }
  }

  return { handleCreateProposalHydration }
}
